import { Injectable } from '@angular/core';
import { ApiConfig } from './api.config';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class NotificacaoUsuarioService extends ApiConfig {

  constructor(private http: HttpClient) {
    super();
  }

  listar(idUsuario) {
    try {
      return new Promise(async (resolve) => {
        this.http.get('https://project-5082f113-c983-477a-973.uw.r.appspot.com/NotificacaoUsuario/ListarPorUsuario?idUsuario=' + idUsuario)
          .subscribe(data => {
            resolve(data);
          }, error => {


          });
      });
    } catch (error) {
      alert(error);
    }
  }

  analiseImpacto(body: any) {
    try {
      return new Promise(async (resolve, reject) => {
        this.http.post('https://project-5082f113-c983-477a-973.uw.r.appspot.com/NotificacaoUsuario/AnaliseImpacto', body)
          .subscribe(data => {
            resolve(data);
          }, error => {
            reject(error);
          });
      });
    } catch (error) {
      alert(error);
    }
  }


}

